import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { SharedDataService } from 'src/app/services/app/shared-service/shared-data.service';
import { CompanyService } from 'src/app/services/core/company/company.service';
import { CustomersService } from 'src/app/services/core/services/customers/customers.service';
import { sweetAlert } from 'src/app/utils/swal';
@UntilDestroy()

@Component({
  selector: 'app-add-customer',
  templateUrl: './add-customer.component.html',
  styleUrls: ['./add-customer.component.css']
})
export class AddCustomerComponent {
  customerForm!: FormGroup
  submitted = false;
  customerId: any;
  user: any;
  companies: any;
  selectedCompany: any = '';
  syncToken: any;
  quickBookId: any;

  constructor(
    private companyService: CompanyService,
    private sharedDataService: SharedDataService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private customerService: CustomersService,
    private fb: FormBuilder) { }

  ngOnInit(): void {
    this.getCompanies()
    this.buildForm();
    this.getUser()

    this.activatedRoute.params
      .pipe(untilDestroyed(this)).subscribe((params) => {
        this.customerId = params["id"];
        if (this.customerId) {
          this.getCustomerbyId();
        }
      }
      );
  }


  getUser() {
    this.sharedDataService.getUser().pipe(untilDestroyed(this)).subscribe((data) => {
      if (data) {
        this.user = data;
        if (this.user) {
          this.customerForm.patchValue({
            company: this.user.id
          })
        }
      }
    })
  }


  buildForm() {
    this.customerForm = this.fb.group({
      FullyQualifiedName: ['', Validators.required],
      PrimaryEmailAddr: this.fb.group({
        Address: ['', Validators.required],
      }),
      DisplayName: ['', Validators.required],
      Notes: [''],
      PrimaryPhone: this.fb.group({
        FreeFormNumber: ['', [Validators.required,Validators.pattern(/^\+?[0-9]{10}$/)]],

      }),
      BillAddr: this.fb.group({
        Line1: ['', Validators.required],
        CountrySubDivisionCode: ['', Validators.required],
        City: ['', Validators.required],
        PostalCode: ['', Validators.required],
        Country: ['', Validators.required],
      }),
      reference:this.fb.group({
          name: [''],
          id: [''],
      }),
      Active:[true]
    });
  }


  getCustomerbyId() {
    this.customerService.getCustomersById(this.customerId).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data) {
        this.customerForm.patchValue({
          ...data
        })
        this.selectedCompany = data.company;
        this.syncToken = data.SyncToken;
        this.quickBookId = data.Id;
      }
    })
  }

  get form() {
    return this.customerForm.controls;
  }

  get primaryEmailAddr() {
    return this.customerForm.get('PrimaryEmailAddr') as FormGroup;
  }

  get primaryPhone() {
    return this.customerForm.get('PrimaryPhone') as FormGroup;
  }

  get billAddr() {
    return this.customerForm.get('BillAddr') as FormGroup;
  }

  get reference() {
    return this.customerForm.get('reference') as FormGroup;
  }

  onSave() {
    this.submitted = true;
    if (this.customerForm.invalid || !this.selectedCompany) {
      return;
    }
    const payload = {
      ...this.customerForm.value,
      FullyQualifiedName: this.customerForm.value.FullyQualifiedName || this.customerForm.value.DisplayName,
      company: this.selectedCompany
    }

    if (this.customerId) {
      payload.SyncToken = this.syncToken,
        payload.Id = this.quickBookId
    }

    this.customerService.saveCustomers(this.customerId, payload).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data) {
        this.router.navigateByUrl('/customers')
      }
    }, (err) => {
      sweetAlert("Error", err, "error", "Ok");
    })
  }

  getCompanies() {
    this.companyService.getCompanies({ status: 'created' }).subscribe((data: any) => {
      if (data) {
        this.companies = data.results
      }
    })
  }

  ngOnDestroy(): void {

  }

  onSelectAddress(place: any): void {

    const selectedAddress = place.address_components;
    // city
    const city = selectedAddress.find((data: any) =>
      data.types.includes('locality') || data.types.includes('administrative_area_level_2')
    );
    const cityName = city ? city.long_name : '';

    // state
    const state = selectedAddress.find((data: any) =>
      data.types.includes('administrative_area_level_1')
    );
    const stateName = state ? state.short_name : '';

    // Postal Code
    const postalCode = selectedAddress.find((data: any) =>
      data.types.includes('postal_code')
    );
    const postalCodeValue = postalCode ? postalCode.long_name : '';

    // Country
    const country = selectedAddress.find((data: any) =>
      data.types.includes('country')
    );
    const countryName = country ? country.long_name : '';

    this.customerForm.patchValue({
      BillAddr: {
        Line1: place.formatted_address,
        CountrySubDivisionCode: stateName,
        City: cityName,
        PostalCode: postalCodeValue,
        Country: countryName
      }
    });


  }
  toggleActive(event: Event) {
    const isChecked = (event.target as HTMLInputElement).checked;
    this.customerForm.patchValue({
      Active: isChecked,
    });
  }
}
